import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';
import { removeUndefined } from 'commonUtils/removeUndefined';

import type { TLoansApplicationV2Data } from 'shared/types/TLoansService';

const getSummaryRawNumber = (label: string, summaries: MPLPreApprovalOffer['summaries'] = []): number | undefined => {
  const valueRaw = summaries?.find((summary) => summary.label === label)?.valueRaw;

  if (typeof valueRaw === 'number') {
    return valueRaw;
  }

  if (valueRaw && typeof valueRaw.from === 'number') {
    return valueRaw.from;
  }

  return undefined;
};

export const mapMplSummariesToApplicationData = (
  summaries: MPLPreApprovalOffer['summaries'] = [],
  productType?: MPLPreApprovalOffer['productType'],
): Partial<TLoansApplicationV2Data['customer']> => {
  const loanGracePeriod = getSummaryRawNumber('LoanGracePeriod', summaries);
  const loanPerMonth = getSummaryRawNumber('LoanPerMonth', summaries);
  const loanRate = getSummaryRawNumber('LoanRate', summaries);
  const loanGracePeriodUnit = productType === 'credit' ? 'month' : 'day';

  return removeUndefined({
    loanGracePeriodUnit: loanGracePeriod ? loanGracePeriodUnit : undefined,
    loanGracePeriod,
    loanPerMonth: loanPerMonth?.toString(),
    loanRate: loanRate?.toString(),
  });
};
